module.exports = __webpack_public_path__ + "media/application/images/ui/icon-search-white-2b3e9ea83230256e8451e9c34f006148.png";